import Form from 'components/Forms/Form/Form';
import {
  Box,
  InputWrap,
  Label,
  ListDate,
  StyledTitle,
  WrapDate,
} from './ModalLeaveRequest.styled';
import { Formik } from 'formik';
import Input from 'componentsReusable/Inputs/Input/Input';
import { useAuth } from 'hooks';
import {
  ButtonAdd,
  WrapPhone,
  WrapPhoneInput,
} from 'components/Forms/FormPersonalDataPatient/FormPersonalDataPatient.styled';
import PhoneInputField from 'components/PhoneImput/PhoneInput';
import InputRadio from 'componentsReusable/Inputs/InputRadio/InputRadio';
import { problemsListValue } from 'helpers/problemsList';
import Checkbox from 'components/Checkbox/Checkbox';
import {
  FieldCheckboxStyled,
  LabelCheckbox,
  TextCheckbox,
} from 'components/Forms/FormLogin/FormLogin.styled';
import InputDate from 'componentsReusable/Inputs/InputDate/InputDate';
import { nanoid } from '@reduxjs/toolkit';
import InputFromTo from 'componentsReusable/Inputs/InputFromTo/InputFromTo';
import { districtsListValue } from 'helpers/districtsList';

const { default: Modal } = require('componentsReusable/Modal/Modal');
const { createPortal } = require('react-dom');

const ModalLeaveRequest = ({ onClick }) => {
  let { error } = useAuth();
  error && console.log('error', error);

  const onSubmit = value => {
    console.log('value', value);
  };

  return createPortal(
    <Modal onClick={() => onClick()} $padding="80px 160px">
      <Box>
        <StyledTitle type="modal">
          Залиште свою заявку, і лікар з вами зв’яжеться!
        </StyledTitle>
        <Formik
          initialValues={{
            lastName: '',
            firstName: '',
            phones: [],
            dateOfReception: [
              {
                id: nanoid(),
                day: '',
                from: '',
                to: '',
              },
            ],
            preferredHours: ['', ''],
            age: '',
            location: '',
            problem: '',
            needPediatricDentist: '',
            budget: '',
            descriptionProblem: '',
          }}
          // validationSchema={validationDoctorPageSchema}
          onSubmit={onSubmit}
        >
          {({
            values,
            errors,
            touched,
            setFieldValue,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldTouched,
          }) => {
            return (
              <Form
                // onSubmit={handleSubmit}
                isRequiredFields
                // save={() => onSubmit(values)}
                sendRequest={() => onSubmit(values)}
              >
                <InputWrap>
                  <Label>
                    <Input
                      width="800px"
                      $error={
                        errors.lastName && touched.lastName && errors.lastName
                      }
                      type={'text'}
                      value={values.lastName}
                      name="lastName"
                      onChange={e => {
                        error = null;
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      required
                      placeholder="Прізвище"
                    />
                  </Label>

                  <Label>
                    <Input
                      width="800px"
                      $error={
                        errors.firstName &&
                        touched.firstName &&
                        errors.firstName
                      }
                      type={'text'}
                      value={values.firstName}
                      name="firstName"
                      onChange={e => {
                        error = null;
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      required
                      placeholder="Ім’я"
                    />
                  </Label>

                  <WrapPhone>
                    <WrapPhoneInput>
                      {(values.phones.length === 0
                        ? ['']
                        : [...(values.phones || '')]
                      ).map(phone => {
                        const index = values.phones.indexOf(phone);
                        return (
                          <Label key={values.phones.length === 0 ? 0 : index}>
                            <Input
                              width="800px"
                              as={PhoneInputField}
                              $error={null}
                              value={phone}
                              field={{ name: 'phones', value: phone }}
                              setFieldValue={value => {
                                const newPhones = [...values.phones];
                                if (
                                  values.phones.indexOf('') &&
                                  values.phones.indexOf('') !== index &&
                                  value === ''
                                ) {
                                  newPhones.splice(index, 1);
                                } else {
                                  if (
                                    value !== '' &&
                                    values.phones.indexOf(value) !== -1
                                  ) {
                                    return;
                                  }
                                  newPhones.splice(index, 1, value);
                                }

                                setFieldValue(
                                  'phones',
                                  index === -1 ? [value] : newPhones
                                );
                              }}
                              required
                              // showPlaceholder={phone}
                              placeholder="+380 __ ___ ____"
                            />
                          </Label>
                        );
                      })}
                    </WrapPhoneInput>
                    <ButtonAdd
                      disabled={
                        values.phones.indexOf('') !== -1 ||
                        values.phones.length === 0
                      }
                      type="button"
                      onClick={() => {
                        const newPhones = [...values.phones];
                        newPhones.push('');
                        setFieldValue('phones', newPhones);
                      }}
                    >
                      + Додати номер телефону
                    </ButtonAdd>
                  </WrapPhone>

                  <Label>
                    <ListDate>
                      {values.dateOfReception.map(dateValue => {
                        const index = values.dateOfReception.findIndex(
                          option => option.id === dateValue.id
                        );
                        return (
                          <WrapDate key={dateValue.id}>
                            <InputDate
                              width="300px"
                              selectedValue={dateValue.day}
                              name="dateOfReception"
                              onChange={value => {
                                const newDateOfReception = [
                                  ...values.dateOfReception,
                                ];

                                newDateOfReception.splice(index, 1, {
                                  ...dateValue,
                                  day: value,
                                });

                                setFieldValue(
                                  'dateOfReception',
                                  newDateOfReception
                                );
                              }}
                              required
                              type="date"
                              placeholder=""
                            />

                            {/* <InputHours
                              disabled={!dateValue.day}
                              width="300px"
                              selectedValue={dateValue}
                              name="dateOfReception"
                              onChange={value => {
                                const newDateOfReception = [
                                  ...values.dateOfReception,
                                ];

                                newDateOfReception.splice(index, 1, value);

                                setFieldValue(
                                  'dateOfReception',
                                  newDateOfReception
                                );
                              }}
                              required
                              type="date"
                              placeholder=""
                            /> */}

                            <InputFromTo
                              error={
                                errors.job &&
                                touched?.job &&
                                touched?.job[index]?.years &&
                                errors?.job[index]?.years
                              }
                              onChange={newValue => {
                                // setSubmitting(false);
                                let newWorkHours = [...values.dateOfReception];
                                newWorkHours[index] = {
                                  ...newWorkHours[index],
                                  receptionHours: newValue,
                                };
                                setFieldValue('dateOfReception', newWorkHours);
                              }}
                              setFieldTouched={() => {
                                const newTouched = touched.job
                                  ? [...touched.job]
                                  : [];
                                newTouched[index] = touched.job
                                  ? {
                                      ...touched.job[index],
                                      years: true,
                                    }
                                  : { years: true };
                                setFieldTouched('dateOfReception', newTouched);
                              }}
                              type={'time'}
                              value={values.dateOfReception}
                              width="250px"
                              placeholder="Години прийому"
                              disabled={!dateValue.day}
                              // isSubmitting={isSubmitting}
                            />
                          </WrapDate>
                        );
                      })}
                    </ListDate>

                    <ButtonAdd
                      disabled={
                        values.dateOfReception.findIndex(
                          option => option.day === ''
                        ) !== -1 ||
                        values.dateOfReception.length === 0 ||
                        values.dateOfReception.length >= 3
                      }
                      type="button"
                      onClick={() => {
                        const newDate = [...values.dateOfReception];
                        newDate.push({
                          id: nanoid(),
                          day: '',
                          from: '',
                          to: '',
                        });
                        setFieldValue('dateOfReception', newDate);
                      }}
                    >
                      + Додати дату
                    </ButtonAdd>
                  </Label>

                  <Label>
                    <Input
                      width="800px"
                      $error={errors.age && touched.age && errors.age}
                      type={'text'}
                      value={values.age}
                      name="age"
                      onChange={e => {
                        error = null;
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      required
                      placeholder="Вік, років"
                    />
                  </Label>

                  <InputRadio
                    width="800px"
                    selectedValue={values.location}
                    values={districtsListValue}
                    name="location"
                    onChange={value => setFieldValue('location', value)}
                    required
                    placeholder="Район міста"
                  />

                  <InputRadio
                    width="800px"
                    selectedValue={values.problem}
                    values={problemsListValue}
                    name="problem"
                    onChange={value => setFieldValue('problem', value)}
                    required
                    placeholder="Проблема"
                  />

                  <LabelCheckbox style={{ paddingTop: 0, marginTop: -20 }}>
                    <FieldCheckboxStyled
                      type={'checkbox'}
                      name="needPediatricDentist"
                      // onChange={handleChange}
                      onBlur={handleBlur}
                      component={Checkbox}
                    />
                    <TextCheckbox>потрібен дитячий стоматолог</TextCheckbox>
                  </LabelCheckbox>

                  <Label>
                    <Input
                      width="800px"
                      $error={errors.budget && touched.budget && errors.budget}
                      type={'number'}
                      value={values.budget}
                      name="budget"
                      onChange={e => {
                        error = null;
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      required
                      placeholder="Бюджет, грн"
                    />
                  </Label>

                  <Label>
                    <Input
                      as={'textarea'}
                      error={
                        touched.descriptionProblem && errors.descriptionProblem
                      }
                      width="800px"
                      height="150px"
                      type={'text'}
                      value={values.descriptionProblem}
                      name="descriptionProblem"
                      onChange={e => {
                        error = null;
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      placeholder="Опис проблеми"
                    />
                    <p>Максимум 300 символів</p>
                  </Label>
                </InputWrap>
              </Form>
            );
          }}
        </Formik>
      </Box>
    </Modal>,
    document.querySelector('#modalLeaveRequest')
  );
};

export default ModalLeaveRequest;
